/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { theme } from '../../styles/theme'

interface LoaderProps {
  show: boolean
}

const loaderContainerStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  z-index: ${theme.zIndex.loader};
  display: flex;
  justify-content: center;
  align-items: center;
`

const loaderStyles = css`
  border: 5px solid #f3f3f3;
  border-top: 5px solid ${theme.colors.primary};
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
`

export const Loader = ({ show }: LoaderProps) => {
  if (!show) return null

  return (
    <div css={loaderContainerStyles}>
      <div css={loaderStyles} />
    </div>
  )
}